<template>
  <div v-if="item.title">
    <Loading v-if="loading" />
    <v-container v-else class="py-10">
      <Title>
        {{ item.title }}
      </Title>

      <div
        v-if="item.text"
        class="text-body-2 font-weight-regular mt-8"
        v-html="item.text"
      ></div>
    </v-container>
  </div>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import Title from "../../widgets/Title.vue";

const _config = {
  mod: "recycle",
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    Title,
  },
};
</script>
